import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../context/UserContext'
import { Form, Col,  } from 'react-bootstrap'
import { Dropdown } from 'primereact/dropdown'
import css from '../AnuncioForm.module.css'
import { linkApi } from '../../config'

export default function Versions({ values, setFieldValue }) {
    const [versions, setVersions] = useState([])
    const { user } = useContext(UserContext)

    const handleDropdownChange = (e) => {
        setFieldValue('version.id', e.target.value)
    }

    useEffect(() => {
        let year = values.registration.year
        let power = values.engine.power_cv
        let fuel = values.fuel.id
        let id = values.segment.id

        console.log('power', power)

        const postData = async () => {
            const options = {
                method: 'GET',
                headers: {
                    authorization: 'Bearer ' + user.token,
                },
            }

            const res = await fetch(
                `${linkApi}/v1/cars/versions/${id}/?ano=${year}&combustivel=${fuel}&potencia=${power}`,
                options
            )
                .then((response) => response.json())
                .catch((err) => console.error(err))
            // console.log('res', res)
            const res2 = res.data.sort((b, a) => b.name.localeCompare(a.name))
            setVersions(res2)
        }
        postData()
    }, [
        user.token,
        values.registration.year,
        values.engine.power_cv,
        values.fuel.id,
        values.segment.id,
    ])

    return (
        <div>
            <Form.Group as={Col} controlId="validationFormik03">
                <Form.Label className={css.label}>Versão</Form.Label>
                <Dropdown
                    value={values.version.id}
                    onChange={handleDropdownChange}
                    options={versions}
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Selecionar"
                    filter
                    className="w-full md:w-14rem"
                    style={{ width: '-webkit-fill-available' }}
                />
            </Form.Group>
        </div>
    )
}
